import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["frame", "container"]

  connect() {
    // Close modal on escape key
    this.handleEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.handleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }

  open(event) {
    // Get the modal ID from the button's data attribute
    const button = event.currentTarget
    const modalId = button.dataset.modalTargetParam
    const modal = modalId ? document.getElementById(modalId) : this.containerTarget

    if (modal) {
      modal.classList.remove('hidden')
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // Hide the modal container
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add('hidden')
    }

    // Find the turbo-frame within this modal wrapper
    const frame = this.hasFrameTarget ? this.frameTarget : this.element.querySelector('turbo-frame')

    if (frame) {
      // Clear the turbo frame properly
      frame.removeAttribute('src')
      frame.innerHTML = ""
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.hasContainerTarget && !this.containerTarget.classList.contains('hidden')) {
      this.close()
    }
  }

  stopPropagation(event) {
    // Prevent clicks inside modal from closing it
    event.stopPropagation()
  }
}
